import { Card, CardContent, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { FC } from "react";

interface IActionPreviewItem {
  title: string;
  backroundImageURL: string
}

const ActionPreviewItem: FC<IActionPreviewItem> = ({
  title,
  backroundImageURL
}) => {
  const theme = useTheme();

  return <Card sx={{ 
    width: 345,
    height: 245,
    backgroundImage: `linear-gradient(217deg, rgba(0,0,0,0) 0%, ${theme.palette.primary.main} 100%), url('${backroundImageURL}');`,
    backgroundSize: "100%",
    color: theme.palette.primary.contrastText,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.standard,
    }),
    '&:hover': {
      backgroundImage: `linear-gradient(217deg, rgba(0,0,0,0) 0%, ${theme.palette.primary.main} 90%), url('${backroundImageURL}');`,
      backgroundSize: "110%"
    }
  }}>
    <CardContent sx={{height: "100%", display: "flex", alignItems: "flex-end"}}>
      <Typography variant="h5" sx={{fontWeight: 500}}>{title}</Typography>
    </CardContent>
  </Card>
}

const ActionsPreview: FC = () => {
  return <>
    <Stack 
      spacing={1} 
      direction={{ xs: 'column', sm: 'row' }} 
      justifyContent={{sm: 'center'}}
      alignItems={{xs: 'center'}}
    >
      <ActionPreviewItem
        title={t("common:text.home_landing_concept_supply_title")}
        backroundImageURL="/images/contractationExample.png"
      />
      <ActionPreviewItem
        title={t("common:text.home_landing_concept_invoices_title")}
        backroundImageURL="/images/invoicesGraphExample.png"
      />
      <ActionPreviewItem
        title={t("common:text.home_landing_concept_modify_title")}
        backroundImageURL="/images/contractDetailExample.png"
      />
    </Stack>
  </>
}

export default ActionsPreview;